import {map, Observable} from 'rxjs';

import {ICreateFormRequest, IFormGroup, IGetFormGroupsResponse} from '@core/api/data-access';

import {CyclesService} from './cycles.service';

export class FormsCyclesService {
	constructor(private cyclesService: CyclesService) {}

	/**
	 * Sends a group of forms to a group of users. Each form will be sent to each user as a separate cycle.
	 *
	 * @param request An object containing the information required to send forms to users.
	 * @returns An Observable of type ICreateFormRequest confirming the successful submission of the form group.
	 *
	 * @example
	 * const formRequest: ICreateFormRequest = {
	 *   forms: ['form1', 'form2'],
	 *   users: ['user1Id', 'user2Id'],
	 *   name: 'Form Group 1',
	 *   message: 'Please complete the following forms.',
	 *   reviewer: 'reviewer123',
	 *   triggers: [...], // Specify triggers accordingly
	 *   erpId: 'erp123'
	 * };
	 *
	 * this.sendForm(formRequest).subscribe(
	 *   (response: ICreateFormRequest) => {
	 *     console.log('Form group sent successfully:', response);
	 *   },
	 *   (error) => {
	 *     console.error('Error sending form group:', error);
	 *   }
	 * );
	 */
	sendForms(request: ICreateFormRequest): Observable<ICreateFormRequest> {
		return this.cyclesService.apiService.post<ICreateFormRequest, ICreateFormRequest>(this.cyclesService.getUrl(`forms`), request).pipe(map(() => request));
	}

	/**
	 * Gets a list of form groups.
	 * @returns An Observable of type IFormGroup[] containing the list of form groups.
	 */
	getFormGroup(): Observable<IFormGroup[]> {
		return this.cyclesService.apiService.get<IGetFormGroupsResponse>(this.cyclesService.getUrl(`forms`)).pipe(
			map((response: IGetFormGroupsResponse) => {
				return response?.forms;
			}),
		);
	}
}
